function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99994 5.56793C6.65676 5.56793 5.56787 6.65682 5.56787 8.00005C5.56787 9.34328 6.65676 10.4322 7.99994 10.4322C9.34312 10.4322 10.432 9.34328 10.432 8.00005C10.432 6.65682 9.34312 5.56793 7.99994 5.56793ZM4.06787 8.00005C4.06787 5.82841 5.82831 4.06793 7.99994 4.06793C10.1716 4.06793 11.932 5.82841 11.932 8.00005C11.932 10.1717 10.1716 11.9322 7.99994 11.9322C5.82831 11.9322 4.06787 10.1717 4.06787 8.00005Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00012 0.25C8.41434 0.25 8.75012 0.585786 8.75012 1V2.27364C8.75012 2.68785 8.41434 3.02364 8.00012 3.02364C7.58591 3.02364 7.25012 2.68785 7.25012 2.27364V1C7.25012 0.585786 7.58591 0.25 8.00012 0.25Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00012 12.9778C8.41434 12.9778 8.75012 13.3136 8.75012 13.7278V15.0014C8.75012 15.4156 8.41434 15.7514 8.00012 15.7514C7.58591 15.7514 7.25012 15.4156 7.25012 15.0014V13.7278C7.25012 13.3136 7.58591 12.9778 8.00012 12.9778Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.51862 2.51813C2.81152 2.22524 3.28639 2.22524 3.57928 2.51814L4.48355 3.42242C4.77644 3.71532 4.77644 4.19019 4.48354 4.48308C4.19065 4.77597 3.71578 4.77597 3.42288 4.48307L2.51862 3.57879C2.22572 3.28589 2.22573 2.81102 2.51862 2.51813Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5175 11.5173C11.8104 11.2244 12.2853 11.2244 12.5782 11.5173L13.4825 12.4216C13.7753 12.7145 13.7753 13.1893 13.4824 13.4822C13.1896 13.7751 12.7147 13.7751 12.4218 13.4822L11.5175 12.5779C11.2246 12.285 11.2246 11.8102 11.5175 11.5173Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.25 7.99994C0.25 7.58573 0.585786 7.24994 1 7.24994H2.27362C2.68783 7.24994 3.02362 7.58573 3.02362 7.99994C3.02362 8.41415 2.68783 8.74994 2.27362 8.74994H1C0.585786 8.74994 0.25 8.41415 0.25 7.99994Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9778 7.99994C12.9778 7.58573 13.3136 7.24994 13.7278 7.24994H15.0014C15.4156 7.24994 15.7514 7.58573 15.7514 7.99994C15.7514 8.41415 15.4156 8.74994 15.0014 8.74994H13.7278C13.3136 8.74994 12.9778 8.41415 12.9778 7.99994Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.48354 11.5173C4.77644 11.8102 4.77644 12.285 4.48355 12.5779L3.57928 13.4822C3.28639 13.7751 2.81152 13.7751 2.51862 13.4822C2.22573 13.1893 2.22572 12.7145 2.51862 12.4216L3.42288 11.5173C3.71578 11.2244 4.19065 11.2244 4.48354 11.5173Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4824 2.51813C13.7753 2.81102 13.7753 3.28589 13.4825 3.57879L12.5782 4.48307C12.2853 4.77597 11.8104 4.77597 11.5175 4.48308C11.2246 4.19019 11.2246 3.71532 11.5175 3.42242L12.4218 2.51814C12.7147 2.22524 13.1896 2.22524 13.4824 2.51813Z"
});

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.5622820a.svg";
export { ForwardRef as ReactComponent };